import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import axios from 'config/axios';
import TextInput from 'components/TextInput';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import OnboardingVector from 'assets/vectors/Onboarding.svg';
import CountryCodes from 'assets/json/countries.json';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { signIn } from 'store/user';
import { setAlert, setError } from 'store/error';
import './index.css';

const GENDERS = [
    'Male',
    'Female',
    'Prefer not to say'
];

function Onboarding() {
    const defaultCountry = CountryCodes.find(country => country.isoCode === 'US');

    const [step, setStep] = useState(1);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const dispatch = useAppDispatch();
    const { organization } = useAppSelector(state => state.organization);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        
        if (firstName && lastName) {
            axios.post('students/sign-up/', {
                    firstName: firstName,
                    lastName: lastName,
                    countryCode: null,
                    phoneNumber: null,
                    gender: null,
                    birthDate: null,
                    parentInfo: null,
                    highSchool: null,
                    classOf: null,
                    postalCode: null,
                    organization: organization.alias
                })
                .then(res => {
                    // console.log(res.data);
                    dispatch(signIn(res.data?.user));

                    ReactGA.event('sign_up');
                })
                .catch(error => {
                    // console.log(error);
                    dispatch(setError(error));
                });
        }
        else {
            dispatch(setAlert({
                response: {
                    data: {
                        message: 'Please fill in all the required fields.'
                    }
                }
            }));
        }
    }

    return (
        <div className='layout'>
            <Helmet>
                <title>
                    Complete sign up - {organization.name}
                </title>
            </Helmet>
            <form className='onboarding' onSubmit={handleSubmit}>
                <img
                    className='onboarding__vector'
                    src={OnboardingVector}
                    alt='Onboarding'
                />
                <h1 className='onboarding__header'>
                    Tell us more about you
                </h1>
                {step === 1 &&
                    <>
                        <div className='onboarding__formGrid'>
                            <TextInput
                                className='onboarding__formGridItem'
                                name='firstName'
                                label='First name'
                                onChange={(event) => setFirstName(event.target.value)}
                                required
                                type='text'
                                value={firstName}
                            />
                            <TextInput
                                className='onboarding__formGridItem'
                                name='lastName'
                                label='Last name'
                                onChange={(event) => setLastName(event.target.value)}
                                required
                                type='text'
                                value={lastName}
                            />
                        </div>
                    </>
                }
                <Button 
                    className='onboarding__button'
                    // disabled={buttonDisabled}
                    fullWidth
                    // secondary={buttonDisabled}
                    type='submit'
                >
                    NEXT
                </Button>
            </form>
        </div>
    );
}

export default Onboarding;